"use client";

import AutoGeolocate from "@/features/auto-geolocate";
import { SelectLocation } from "@/features/location";
import { SearchButton } from "@/features/search";
import { Container } from "@/shared/ui";
import { HStack, Image } from "@chakra-ui/react";

export function Header() {
  return (
    <>
      <AutoGeolocate />
      <Container w="full" direction="column" gap="2">
        <HStack alignItems="center" py="2">
          <Image src="/logo.svg" alt="logo" w="50px" h="50px" />
          <SelectLocation />
        </HStack>

        {/* Search product or brands */}
        <SearchButton />
      </Container>
    </>
  );
}
